import { JSX, ReactNode } from "react"

import "./buttons.css"

type Props = {
  children: ReactNode
  onClick: () => void
}
export default function Button({ children, onClick }: Props): JSX.Element {
  return (
    <button className="button" onClick={onClick}>
      {children}
    </button>
  )
}
